<template>
  <div class="input-container">
    <span
      v-if="charactersRemaining < 1000"
      class="char-count pull-right"
    >
      {{ charactersRemaining }} characters remaining
    </span>
    <div class="form-inline">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon">
            <button
              class="btn btn-link"
              @click="$emit('attachFile')"
            >
              Upload File
            </button>
          </span>
          <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
          <textarea
            :id="`form-field-${name}`"
            v-model="mutableValue"
            v-validate="validation"
            v-bind="actions"
            :data-vv-name="`form-field-${name}`"
            :class="{'is-danger': errors.has(`form-field-${name}`)}"
            :disabled="disabled"
            :rows="rows"
            class="form-control"
            placeholder="Please click here and type your message"
            @keyup.ctrl.enter="submit"
          />
        </div>
        <button
          :disabled="disabled"
          class="btn btn-primary send-button"
          @click="submit"
        >
          <font-awesome-icon
            v-if="disabled"
            icon="circle-notch"
            spin
          />
          <span v-else>Send</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Field from '../../../partials/field.vue';

export default {
  extends: Field,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxCharacters: 10000,
    };
  },
  computed: {
    characters() {
      if (!this.valueIsString()) {
        return 0;
      }

      return this.mutableValue.length;
    },
    charactersRemaining() {
      return this.maxCharacters - this.characters;
    },
    rows() {
      if (!this.valueIsString()) {
        return 2;
      }

      return Math.max(this.mutableValue.split(/\r*\n/).length, 2);
    },
  },
  methods: {
    submit() {
      if (!this.mutableValue || /^\s*$/.test(this.mutableValue)) {
        return;
      }

      this.$emit('submitted', this.mutableValue);
      this.mutableValue = this.value;
    },
    valueIsString() {
      return (typeof this.mutableValue === 'string' || this.mutableValue instanceof String);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  .form-group {
    width: 100%;
    .input-group {
      .input-group-addon {
        width: 11px;
      }

      textarea {
        resize: none;
        line-height: 1.1;
        padding: 3px 12px 0;
      }

      // Don't collapse on mobile
      display: inline-table !important;
      vertical-align: bottom !important;

      width: calc(100% - 63px);
    }
  }
  .char-count {
    font-size: 0.8em;
    color: grey;
  }
}

button.send-button {
  border-radius: 4px !important;
  box-sizing: border-box;
  width: 60px;
}
</style>
